export const TRANSLATIONS_SVE = {
  username: "Användarnamn",
  password: "Lösenord",
  login: "INLOGGEN",
  registerMsg: "Nog niet geregistreerd?",
  registerMsg2: "Klik hier",
  modalMsg: "Fel lösenord och/eller användarnamn",
};
